

































































































import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { ProjectMemberRating } from '@/@types/ProjectMember';

@Component({
  components: {
    CommonModalHeader,
    CommonButton,
    AccountIcon,
  },
})
export default class LeaveMemberModal extends Vue {
  @Prop({ required: true })
  private isOpenLeaveMemberModal!: boolean;

  private modalHeaderTitle = 'プロジェクトメンバーを離任させます';
  private modalMode = 'delete';
  private isStar: boolean = true;
  private acceptButtonColor: string = '#4384f3';
  private denyButtonColor: string = '#fa5f7e';
  private projectMemberRating: ProjectMemberRating = {
    technique: 3,
    communication: 3,
    understanding: 3,
    comment: '',
  }

  @Emit('closeLeaveMemberModal')
  private closeLeaveMemberModal() {}

  @Emit('sendProjectMemberRating')
  private sendProjectMemberRating() {
    return this.projectMemberRating;
  }

  private disableRate() {
    this.isStar = false;
    this.projectMemberRating.technique = null;
    this.projectMemberRating.communication = null;
    this.projectMemberRating.understanding = null;
  }

  private doRate() {
    this.isStar = true;
    this.projectMemberRating.technique = 3;
    this.projectMemberRating.communication = 3;
    this.projectMemberRating.understanding = 3;
  }
}
